import React from 'react'
import generalSyles from '../../styles/general.module.css'
import { Container, Grid } from '@material-ui/core'
import CustomServicesCard from '../../modules/custom_services_card'
import getStringsBasedLang from '../../strings/get_strings'
import styles from './services.module.css'

export default function Services() {

    return (
        <Container>
            <div className={styles.container}>
                <span className={generalSyles.title}>{getStringsBasedLang("general_viraServicesTitle")}</span>
                <span className={generalSyles.subTitle}>{getStringsBasedLang("general_viraServicesSubTitle")}</span>
                <div className={styles.card_container}>
                    <img className={styles.wave_left} src={require('../../assets/img/wave_line1.svg').default} alt="Image" />
                    <img className={styles.wave_right} src={require('../../assets/img/wave_line1.svg').default} alt="Image" />
                    <Grid style={{ justifyContent: "center" }} container spacing={3}>
                        <Grid item sm={12} md={6} lg={4}>
                            <CustomServicesCard title={getStringsBasedLang("services_autoReview")} num={1} img="automation" des={getStringsBasedLang("scanWithMultipaleAv")} />
                        </Grid>
                        <Grid item sm={12} md={6} lg={4}>
                            <CustomServicesCard title={getStringsBasedLang("srvices_SpecializedReports")} num={2} img="specialized_report" des={getStringsBasedLang("differentFormats")} />
                        </Grid>
                        <Grid item sm={12} md={6} lg={4}>
                            <CustomServicesCard title={getStringsBasedLang("srvices_dynamicAnalysis")} num={3} img="static_analysis" des={getStringsBasedLang("updatedTools")} />
                        </Grid>
                    </Grid>
                </div>
            </div>
        </Container>
    )
}